/* eslint-disable class-methods-use-this */
import React from 'react';
import { ICellRendererParams, ICellRendererComp } from '@ag-grid-community/core';
import ReactDOMServer from 'react-dom/server';
import ReactJsonView from './ReactJsonView';

class DetailCellRenderer extends React.Component implements ICellRendererComp {
  eGui!: HTMLElement;

  init(params: ICellRendererParams) {
    this.eGui = document.createElement('div');
    this.eGui.innerHTML = ReactDOMServer.renderToString(
      <ReactJsonView
        data={params.data}
        status={params.data.status}
      />,
    );
  }

  getGui() {
    return this.eGui;
  }

  refresh(params: any): boolean {
    return false;
  }
}

export default DetailCellRenderer;
